// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"285":"app-messages-fr_CA","3546":"app-messages-en_CA","5496":"app-messages-any_Ext","6586":"product-metadata","7294":"app-messages-en_US"}[chunkId] + "." + {"285":"d3fca137","3546":"0f36a94a","5496":"cd5677aa","6586":"a606690d","7294":"fcf71965"}[chunkId] + ".chunk.js";
};